import { all } from 'redux-saga/effects';
import { watchAddressDataAsync } from '@/redux/ui/address';
import { watchPHPAddressDataAsync } from '@/redux/ui/address-php';
import { watchUploadAsync } from '@/redux/imgs/viewsAndUpload';
import { watchActionSheetUploadAsync } from '@/redux/ui/actionsheet';
import { watchProductCategoryDataAsync } from '@/redux/ui/category-product';
import { watchAppCategoryDataAsync } from '@/redux/ui/category-app';

// 导出一个总saga入口，利用all并行相关监听
export default function* rootSaga() {
    yield all([
        watchAddressDataAsync(),
        watchPHPAddressDataAsync(),
        watchActionSheetUploadAsync(),
        watchUploadAsync(),
        watchProductCategoryDataAsync(),
        watchAppCategoryDataAsync()
    ]);
}